var FastBase64 = { // an object called FastBase64
  chars: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=", // property called chars is a string value
  encLookup: [], // property called encLookup is an empty array

  Init: function () { // method called Init is a function
    for (var i = 0; i < 4096; i++) { // loops 4096 times
      this.encLookup[i] = this.chars[i >> 6] + this.chars[i & 0x3F]; // assigns property encLookup[i] to some weird two letter string
      //console.log('this.encLookup', this.encLookup[i]);
    }
  },

  Encode: function (src) {
    //console.log('src',src) // an array of numbers...alot of numbers
    var len = src.length; // length of array
    //console.log('src.length', src.length)
    var dst = ''; // an empty string
    var i = 0; // declare a variable that has a value of 0
    while (len > 2) { // while length is greater than 2
      var n = (src[i] << 16) | (src[i + 1] << 8) | src[i + 2]; // seemingly random numbers (different lengths) bitwise shift operators
      //console.log('n', n)
      dst += this.encLookup[n >> 12] + this.encLookup[n & 0xFFF]; // is this the wav file holy crap largest string ever.
      len -= 3; // subtracting 3 from len
      i += 3; // adding 3 to len
    }
    if (len > 0) { // len is greater than 0
      var n1 = (src[i] & 0xFC) >> 2; // declare a variable n1 and bitwise shift operator some weird stuff.
      var n2 = (src[i] & 0x03) << 4; // declare a varaible n2 and bitwise shift operator some weird stuff.
      if (len > 1) n2 |= (src[++i] & 0xF0) >> 4; // if len > 1
      dst += this.chars[n1]; // append this.chars[n1] to dst+
      dst += this.chars[n2]; // append this.chars[n2] to dst+
      if (len === 2) {
        var n3 = (src[i++] & 0x0F) << 2; // src[i++]
        n3 |= (src[i] & 0xC0) >> 6;
        dst += this.chars[n3];
      }
      if (len === 1) dst += '='; // if len == 1, append '=' to dst string
      dst += '='; // append '=' to dst
    }
    return dst;
  }

};

FastBase64.Init(); // run FastBase64

var RIFFWAVE = function (data) {
  this.data = [];        // Array containing audio samples
  this.wav = [];         // Array containing the generated wave file
  this.dataURI = '';     // http://en.wikipedia.org/wiki/Data_URI_scheme

  this.header = {                         // OFFS SIZE NOTES
    chunkId: [0x52, 0x49, 0x46, 0x46], // 0    4    "RIFF" = 0x52494646
    chunkSize: 0,                     // 4    4    36+SubChunk2Size = 4+(8+SubChunk1Size)+(8+SubChunk2Size)
    format: [0x57, 0x41, 0x56, 0x45], // 8    4    "WAVE" = 0x57415645
    subChunk1Id: [0x66, 0x6d, 0x74, 0x20], // 12   4    "fmt " = 0x666d7420
    subChunk1Size: 16,                    // 16   4    16 for PCM
    audioFormat: 1,                     // 20   2    PCM = 1
    numChannels: 1,                     // 22   2    Mono = 1, Stereo = 2...
    sampleRate: 8000,                  // 24   4    8000, 44100...
    byteRate: 0,                     // 28   4    SampleRate*NumChannels*BitsPerSample/8
    blockAlign: 0,                     // 32   2    NumChannels*BitsPerSample/8
    bitsPerSample: 8,                     // 34   2    8 bits = 8, 16 bits = 16
    subChunk2Id: [0x64, 0x61, 0x74, 0x61], // 36   4    "data" = 0x64617461
    subChunk2Size: 0                      // 40   4    data size = NumSamples*NumChannels*BitsPerSample/8
  };

  // 8bit array to a 32bit array
  function u32ToArray(i) {
    //console.log(" u32ToArray", [i&0xFF, (i>>8)&0xFF, (i>>16)&0xFF, (i>>24)&0xFF])
    return [i & 0xFF, (i >> 8) & 0xFF, (i >> 16) & 0xFF, (i >> 24) & 0xFF];
  }

  // 8bit array to a 16bit array
  function u16ToArray(i) {
    //console.log(" u16ToArray", [i&0xFF, (i>>8)&0xFF])
    return [i & 0xFF, (i >> 8) & 0xFF];
  }

  function split16bitArray(data) {
    var r = []; // declare an empty array called r
    var j = 0; // declare variable called j and give a number value of 0
    var len = data.length; // declare a variable called len and give it a value of data.length
    for (var i = 0; i < len; i++) { // loop while i is less than len
      r[j++] = data[i] & 0xFF;

      r[j++] = (data[i] >> 8) & 0xFF;
    }
    console.log('split16bitarray returns: ', r);
    return r;
  }

  // ADD FOLLOWING CODE TO GET INSTANCE METHOD.
  this.Make = function (data) { // the Make function is declared. It has a data argument
    if (data instanceof Array) this.data = data; // if data is an array, this.data is = data
    this.header.blockAlign = (this.header.numChannels * this.header.bitsPerSample) >> 3;
    this.header.byteRate = this.header.blockAlign * this.sampleRate;
    this.header.subChunk2Size = this.data.length * (this.header.bitsPerSample >> 3);
    this.header.chunkSize = 36 + this.header.subChunk2Size;

    this.wav = this.header.chunkId.concat(
      u32ToArray(this.header.chunkSize),
      this.header.format,
      this.header.subChunk1Id,
      u32ToArray(this.header.subChunk1Size),
      u16ToArray(this.header.audioFormat),
      u16ToArray(this.header.numChannels),
      u32ToArray(this.header.sampleRate),
      u32ToArray(this.header.byteRate),
      u16ToArray(this.header.blockAlign),
      u16ToArray(this.header.bitsPerSample),
      this.header.subChunk2Id,
      u32ToArray(this.header.subChunk2Size),
      (this.header.bitsPerSample === 16) ? split16bitArray(this.data) : this.data
    );
    this.dataURI = 'data:audio/wav;base64,' + FastBase64.Encode(this.wav);
  };
  if (data instanceof Array) this.Make(data);

}; // end RIFFWAVE

var cols = [1209, 1336, 1477, 1633]; // making arrays for column
var rows = [697, 770, 852, 941]; // making array for rows

var tones = {}; // making a tones object
for (var c = 0; c < cols.length; c++) { // looping through cols

  for (var r = 0; r < rows.length; r++) { // looping through rows
    var data = []; // creating an empty array called data.
    var PI2 = Math.PI * 2; // a variable called PI2 with a value of Math.PI * 2
    var riff = new RIFFWAVE(); // assigning variable riff to value of new RIFFWAVE();
    //console.log('riffffffffffff', riff);
    riff.header.sampleRate = 8000; // riff.header.sampleRate value is 8000
    for (var i = 0; i < 10000; i++) { // looping 10000 times apparently.
      var tone1 = Math.sin((PI2 * rows[c] * i) / riff.header.sampleRate); // declared variable tone1 and gave it value
      var tone2 = Math.sin((PI2 * cols[r] * i) / riff.header.sampleRate); // declared variable tone2 and gave it value
      data.push(128 + Math.round(127 * ((tone1 + tone2) / 2))); // pushed some fancy number to data array.
    }
    //console.log('>>>>>aye data', data);
    riff.Make(data); // calling the Make function with the data array.

    switch (c + "x" + r) { // switched based on concatenated c + "x" + r plays a specific tone.

      case "0x0":
        tones['1'] = riff.dataURI;
        break;
      case "0x1":
        tones['4ghi'] = riff.dataURI;
        break;
      case "0x2":
        tones['7pqrs'] = riff.dataURI;
        break;
      case "0x3":
        tones['*'] = riff.dataURI;
        break;
      case "1x0":
        tones['2abc'] = riff.dataURI;
        break;
      case "1x1":
        tones['5jkl'] = riff.dataURI;
        break;
      case "1x2":
        tones['8tuv'] = riff.dataURI;
        break;
      case "1x3":
        tones['0'] = riff.dataURI;
        break;
      case "2x0":
        tones['3def'] = riff.dataURI;
        break;
      case "2x1":
        tones['6mno'] = riff.dataURI;
        break;
      case "2x2":
        tones['9wxyz'] = riff.dataURI;
        break;
      case "2x3":
        tones['#'] = riff.dataURI;
        break;
      default:
      //console.log('not needed')
    }

  }
}

export default tones;
